import { useEffect } from 'react';
import { VerticalNavigation } from '@zg-rentals/rental-manager-header-navigation';

import {
  StyledBodyContainer,
  StyledBodyContentContainer,
  StyledHorizontalLayoutContainer,
  StyledVerticalNavigationContainer,
} from './styles';

import type { HeaderNavigationProps } from '@zg-rentals/rental-manager-header-navigation';

type Props = HeaderNavigationProps & {
  /**
   * altLogo true - zrm logo
   * altLogo false - zillow logo
   */
  altLogo?: boolean;
  hideHeaderNavigation?: boolean;
  bodyContent?: React.ReactNode;
  /*
   * pathname
   *
   * the current path so the link can be highlighted
   */
  pathname: string;
};

const HorizontalLayoutContainer = ({ bodyContent, hideHeaderNavigation = false, pathname, ...rest }: Props) => {
  useEffect(() => {}, [bodyContent]);

  return (
    <StyledHorizontalLayoutContainer data-testid="HorizontalLayoutContainer">
      {hideHeaderNavigation === false && (
        <StyledVerticalNavigationContainer hideHeaderNavigation={hideHeaderNavigation}>
          <VerticalNavigation pathname={pathname} displayMainMaintenanceTracker={false} {...rest} />
        </StyledVerticalNavigationContainer>
      )}

      <StyledBodyContainer data-testid="BodyContainer" hideHeaderNavigation={hideHeaderNavigation}>
        <StyledBodyContentContainer data-testid="BodyContentContainer">{bodyContent}</StyledBodyContentContainer>
      </StyledBodyContainer>
    </StyledHorizontalLayoutContainer>
  );
};

const HorizontalLayoutVerticalNavigationContainer = ({
  altLogo = true,
  hideHeaderNavigation = false,
  pathname,
  ...rest
}: Props) => {
  return (
    <StyledVerticalNavigationContainer
      data-testid="VerticalNavigationContainer"
      hideHeaderNavigation={hideHeaderNavigation}
    >
      <VerticalNavigation altLogo={altLogo} pathname={pathname} displayMainMaintenanceTracker={false} {...rest} />
    </StyledVerticalNavigationContainer>
  );
};

export { HorizontalLayoutVerticalNavigationContainer, HorizontalLayoutContainer };
